import React, { useEffect, useState } from "react";
import { getNewToken } from "../../store/actions/onboarding/getNewToken";
import { logout } from "../../store/actions/user/logout";

import { GiSandsOfTime } from "react-icons/gi";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import MainButton from "../Buttons/MainButton";
import { Cookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const SessionTimeOut = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const cookies = new Cookies();
  const isAccessTokenAvailable = cookies.get("accessToken");
  const { isModalOpened, modalText } = useSelector((state) => state?.message);
  const [timeOut, setTimeout] = useState({
    min: null,
    sec: null,
  });

  const handleGetNewToken = () => {
    dispatch(getNewToken());
  };

  useEffect(() => {
    let clearId;
    if (isAccessTokenAvailable) {
      const token = isAccessTokenAvailable;
      const decoded = jwtDecode(token);
      const newDate = new Date(0);
      const dateOfExp = new Date(newDate.setUTCSeconds(decoded.exp)).getTime();
      newDate.setUTCSeconds(decoded.exp);

      clearId = setInterval(() => {
        const current = new Date().getTime();
        const getSeconds = parseInt(((dateOfExp - current) / 1000) % 60);

        const getMins = parseInt((dateOfExp - current) / (1000 * 60));

        if (getMins < 1 && getSeconds < 1 && isAccessTokenAvailable) {
          dispatch(logout());
          window.location = `/signin`;
        }
        setTimeout({
          min: getMins,
          sec: getSeconds,
        });
      }, 1000);
    }
    return () => {
      if (clearId) {
        clearInterval(clearId);
      }
    };
  }, [isAccessTokenAvailable]);

  return (
    <>
      {(timeOut.min || timeOut.min === 0) && timeOut.min < 6 ? (
        <div className="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-blend-saturation bg-[rgba(0,0,0,0.6)]">
          <div className="w-[500px]  max-w-[85%] rounded-lg bg-[#fff] flex flex-col items-center gap-2 py-11 px-5 sm:px-8">
            <h4 className="font-[600] text-[#101828] mb-1 text-2xl">
              Session Timeout
            </h4>
            <h5 className="  text-xs md:text-sm  lg:text-base  text-center w-[75%] font-[400]  text-[#475467]">
              {`We noticed you have been inactive for a while. We'll sign you
                out in ${
                  timeOut.min > 0
                    ? `${timeOut.min} minute${timeOut.min > 1 ? "s" : ""}`
                    : ""
                } ${timeOut.sec} second${
                timeOut.sec > 1 ? "s" : ""
              } to protect your account.`}
            </h5>
            <div className="mt-6 mb-7">
              <GiSandsOfTime size={150} color={"#101828"} />
            </div>
            <div className="flex justify-between w-full mb-2 gap-4 items-center">
              <MainButton
                onClick={() => {
                  dispatch(logout());
                  window.location = `/signin`;
                }}
                variant="outlined"
                customColor="#fff"
                borderColor="#159AA8"
                color="#159AA8"
                title="Log me out"
                width="199px"
                height="44px"
                // margin="24px"
                padding="10px"
                mainClasses="!h-[52px] !mt-[20px] !mb-0 !text-[#6935D3] !bg-[#FFF] !border-[1px] !border-[#6935D3] "
              />
              <MainButton
                mainClasses="!h-[52px] !mt-[20px] !mb-0 text-white"
                onClick={handleGetNewToken}
                variant="contained"
                customColor="#159AA8"
                title="I'm still here"
                width="199px"
                height="44px"
                // margin="24px"
                padding="10px"
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SessionTimeOut;
